<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="name"
    :rules="rules"
    :vid="vid">
    <BaseTextareaGroup
      :field-class="fieldClass"
      :value="_value"
      :label="label"
      :name="name"
      :placeholder="placeholder"
      :rows="rows"
      :disabled="disabled"
      :col="col"
      :empty-str-to-null="emptyStrToNull"
      :errors="[...errors, ...responseFieldErrors]"
      v-on="$listeners" />
  </ValidationProvider>
</template>

<script>
import BaseTextareaGroup from '@/components/parts/BaseTextareaGroup.vue'
export default {
  name: 'BaseTextareaGroupWithProvider',
  components: {
    BaseTextareaGroup,
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    errors: {
      type: Array,
      default: () => []
    },
    col: {
      type: [String, Number],
      default: 12
    },
    name: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    emptyStrToNull: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 5
    },
    responseErrors: {
      type: Object,
      default: null
    },
    vid: {
      type: String,
      default: null
    },
    rules: {
      type: [String, Array],
      default: undefined
    },
    fieldClass: {
      type: String,
      default: null
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
    responseFieldErrors() {
      return this.responseErrors?.[this.vid] || []
    }
  },
}
</script>

<style>

</style>